import React, { ReactNode } from 'react';
import { Button } from 'react-bootstrap';
import Modal from './modal';

interface Props {
    show: boolean;
    onConfirm: () => void;
    onClose: () => void;
    confirmTitle: string;
    confirmMessage: string;
    confirmAction: string;
    rejectAction: string;
    danger?: boolean;
}

function ConfirmModal(props: Readonly<Props>) {
    const btnClass = props.danger ? 'btn btn-danger' : 'btn btn-primary';

    const confirmContent: ReactNode = (
        <>
            <h2>{props.confirmTitle}</h2>
            <p className="mt-2 mb-lg-4">{props.confirmMessage}</p>
            <Button className={btnClass} onClick={handleConfirm}>
                {props.confirmAction}
            </Button>{' '}
            <Button className={'btn'} onClick={handleModalClose}>
                {props.rejectAction}
            </Button>
        </>
    );

    return (
        <Modal show={props.show} onClose={handleModalClose}>
            {confirmContent}
        </Modal>
    );

    function handleModalClose() {
        props.onClose();
    }

    function handleConfirm() {
        props.onConfirm();
    }
}

export default ConfirmModal;
